import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import App from './App';
import './styles.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {/* basename 必须与 vite 的 base 一致。不一致的表现很隐蔽：
        首屏能打开（服务器直接返回了 index.html），但任何一次前端跳转
        都会把 URL 变成 /keys 而不是 /console/keys，刷新即 404。 */}
    <BrowserRouter basename="/console">
      <App />
    </BrowserRouter>
  </StrictMode>,
);
